<template>
  <div class="manifest">

    <Hero image="profile-cover.jpg" layout="half" title="<strong>Manifesto</strong>"/>

    <div class="row pb-5">
      <div class="col-12 col-lg-8 mx-auto mt-n4">

        <div class="bg-white shadow-sm p-5">
          <p>Para nós, a felicidade é uma jornada e um destino.</p> 
          <p>Um destino que <strong>agrega</strong> ideias e reúne pessoas, fortalece laços e tece o futuro.</p>
          <p>Um destino baseado nos encontros, na confiança e no esforço coletivo. No pensamento empreendedor e na inspiração compartilhada, movida por pessoas apaixonadas. Onde os talentos encontram as oportunidades.</p>
          <p>É na felicidade que os desejos são expressados e os sonhos realizados. Nela está o estado de espírito de uma sociedade melhor engajada, com segurança, variedade e lazer para todos.</p>
          <br>

          <h4 class="text-blue-br">Somos a dpsp.</h4> 
          <p>Trabalhamos incansavelmente para proporcionar encontros com a felicidade, em uma infraestrutura de qualidade, orientada para receber cada e qualquer pessoa. E, assim, promover uma convivência feliz.</p>
          <p>E nesta jornada, fazemos questão das melhores companhias. Por isso <strong>convidamos todos</strong> aqueles que também celebram os shoppings como espaços de felicidade a unir sua <strong>energia transformadora</strong>, sua <strong>capacidade de realização</strong> e sua <strong>paixão em servir</strong> para criar mais e melhores oportunidades para todos.</p>
          <p>Porque aqui, todo dia, inspiramos e respiramos felicidade com milhares de pessoas.</p>

        </div>

      </div>
    </div>

  </div>
</template>

<script>  
import Hero from '@/components/media/Hero.vue'

export default {
  name: 'Manifest',

  components: {
    Hero
  },
}
</script>

<style lang="scss"></style>